var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TableSingleStringFilter"},[(_vm.label)?_c('label',{attrs:{"for":_vm.fieldId}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.value)?_c('b-button-close',{staticClass:"btn-sm",on:{"click":_vm.resetFilter}}):_vm._e(),_c('b-input',{attrs:{"id":_vm.fieldId,"value":_vm.value},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }